import {
  Col,
  Card,
  CardBody,
  Row,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
} from "reactstrap";

import { SubjectDto } from "../../interfaces";
import smallImage9 from "../../assets/images/small/img-13.png";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RoleEnum } from "../../enums";
import { AccountState } from "../../store/slices/accountSlice";

type TProps = SubjectDto & {
  onEditSubject?: (id: string) => void;
  onDeleteSubject?: (id: string) => void;
  onCopySubject?: (id: string) => void;
  onCutSubject?: (id: string) => void;
  onSyncSubject?: (id: string) => void;
  onToggleState?: (id: string) => void;
  isChangeable?: boolean;
  linkLabel?: string;
  link: string;
};

export const SubjectCard: React.FC<TProps> = ({
  contentImage,
  id,
  isActive,
  homeImage,
  name,
  onEditSubject,
  onDeleteSubject,
  onCopySubject,
  onCutSubject,
  onSyncSubject,
  onToggleState,
  isChangeable = true,
  linkLabel = "viewDetails",
  link,
  sequenceNumber,
  chaptersCount,
  lessonsCount,
}) => {
  //#region hooks
  const { t, i18n } = useTranslation();
  //#endregion

  //#region redux state
  const profile = useSelector(
    (state: { account: AccountState }) => state.account.userProfile,
  );
  //#endregion

  return (
    <Card className="team-box">
      <div className="team-cover">
        <img src={contentImage || smallImage9} alt="" className="img-fluid" />
      </div>
      <CardBody className="p-4">
        <Row className="align-items-center team-row">
          {isChangeable &&
            profile &&
            profile.role.key == RoleEnum.SUPER_ADMIN && (
              <Col className="team-settings">
                <Row>
                  <Col></Col>
                  <UncontrolledDropdown
                    direction="start"
                    className="col text-end"
                  >
                    <DropdownToggle
                      tag="a"
                      id="dropdownMenuLink2"
                      role="button"
                    >
                      <i className="ri-more-fill fs-17 dropdown-menu-button-custom"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem
                        style={{
                          alignSelf: "flex-start",
                          display: "flex",
                        }}
                        className="dropdown-item edit-list"
                        onClick={() => onEditSubject && onEditSubject(id)}
                      >
                        <i className="ri-pencil-line me-2 align-bottom text-muted"></i>
                        {t("edit")}
                      </DropdownItem>
                      <DropdownItem
                        style={{
                          alignSelf: "flex-start",
                          display: "flex",
                        }}
                        className="dropdown-item edit-list"
                        onClick={() => onToggleState && onToggleState(id)}
                      >
                        <i
                          className={`${
                            isActive
                              ? "ri-forbid-line"
                              : "ri-checkbox-circle-line text-danger"
                          }  me-2 align-bottom text-muted`}
                        ></i>
                        {isActive ? t("deactivate") : t("activate")}
                      </DropdownItem>
                      <DropdownItem
                        style={{
                          alignSelf: "flex-start",
                          display: "flex",
                        }}
                        className="dropdown-item remove-list"
                        onClick={() => onCopySubject && onCopySubject(id)}
                      >
                        <i className="ri-file-copy-line me-2 align-bottom text-muted"></i>
                        {t("copy")}
                      </DropdownItem>
                      <DropdownItem
                        style={{
                          alignSelf: "flex-start",
                          display: "flex",
                        }}
                        className="dropdown-item remove-list"
                        onClick={() => onCutSubject && onCutSubject(id)}
                      >
                        <i className=" ri-scissors-line me-2 align-bottom text-muted"></i>
                        {t("cut")}
                      </DropdownItem>
                      <DropdownItem
                        style={{
                          alignSelf: "flex-start",
                          display: "flex",
                        }}
                        className="dropdown-item edit-list"
                        onClick={() => onSyncSubject && onSyncSubject(id)}
                      >
                        <i className="ri-refresh-line me-2 align-bottom text-muted"></i>
                        {t("sync")}
                      </DropdownItem>
                      <DropdownItem
                        style={{
                          alignSelf: "flex-start",
                          display: "flex",
                        }}
                        className="dropdown-item remove-list"
                        onClick={() => onDeleteSubject && onDeleteSubject(id)}
                      >
                        <i className="ri-delete-bin-5-line me-2 align-bottom text-muted"></i>
                        {t("delete")}
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </Row>
              </Col>
            )}
          <Col lg={4} className="col">
            <div className="team-profile-img">
              <div className="avatar-lg img-thumbnail rounded-circle flex-shrink-0">
                {homeImage != null ? (
                  <img
                    src={homeImage}
                    alt=""
                    className="img-fluid d-block rounded-circle"
                  />
                ) : (
                  <div className="avatar-title text-uppercase border rounded-circle bg-light text-primary">
                    {name.en.charAt(0) +
                      name.en.split(" ").slice(-1).toString().charAt(0)}
                  </div>
                )}
              </div>
              <div className="team-content">
                <h5 className="fs-16 mb-1">
                  {i18n.language === "ar" ? name?.ar : name?.en}
                </h5>
                <Badge color={`${isActive ? "primary" : "danger"}`}>
                  {isActive ? t("active") : t("inActive")}
                </Badge>
                &nbsp;
                <Badge color={`${"secondary"}`}>{sequenceNumber}</Badge>
              </div>
            </div>
          </Col>
          <Col lg={4} className="col">
            <Row className="text-muted text-center">
              <Col xs={6} className="border-end border-end-dashed">
                <h5 className="mb-1">{chaptersCount || 0}</h5>
                <p className="text-muted mb-0">{t("chapters")}</p>
              </Col>
              <Col xs={6}>
                <h5 className="mb-1">{lessonsCount || 0}</h5>
                <p className="text-muted mb-0">{t("lessons")}</p>
              </Col>
            </Row>
          </Col>
          <Col lg={2} className="col">
            <div className="text-end">
              <Link to={link} className="btn btn-light view-btn">
                {t(linkLabel)}
              </Link>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};
